import { techDocs } from "../technical-docs";

export default techDocs('marketing', 'Marketing & Vendas', 'documentos-tecnicos-marketing-vendas')